import route from "../route.js";
import PLPState from "./plp_state.js";
import productType from "./ui/productType_filter.js"
import * as activityLogger from "../helpers/activity-logger";

$(function () {
    if (route === "fine-wine" || route === "fine-spirits") {

        let plpState = PLPState.getInstance();
        plpState.remove("duty");
        plpState.add("duty", 'delivery');

        // When user clicks filter select button => filters and products
        $(document).on(
            "click",
            ".filter-container .multi-select .select-button",
            function (e) {
                activityLogger.logActivity('Filter', route + '-landing-page', plpState.state);
                loadPLP();
            }
        );

        // When user clicks off a filter => reload the filters and products
        $(document).on(
            "closed",
            ".filter-container .multi-select",
            function (e) {
                if ($(this).data("has-changed") === true) {
                    loadPLP();
                }
            }
        );

        $(document).on("change", 'select[name="category"]', {route: route, loadPLP: loadPLP}, function(event) {
            productType(event);
        });

        function loadPLP() {
            // Update the top URL
            axios({
                method: "POST",
                url: `/${route}/load-product-listing-page-url-ajax`,
                data: { filters: plpState.state },
            }).then(function (response) {
                window.location.href = response.data.url;
            });
        }
    }
});
